type UpvaluePayment = {
    is_boost?: boolean | null
    is_agent_payment?: boolean
    amount: number | string
    fee?: number | string | null
}

type WalletUpvalue = {
    from_user_id: string
    to_user_id: string
    is_boost?: boolean | null
    is_agent_payment?: boolean
}

export function upvalueDisplayAmount(payment: UpvaluePayment): number {
    const amount = Number(payment.amount)
    const fee = Number(payment.fee || 0)

    if (payment.is_agent_payment) return amount
    if (payment.is_boost) return fee

    return amount - fee
}

export function upvalueMatchesWalletTab(
    payment: WalletUpvalue,
    activeTab: string,
    currentUserId: string,
): boolean {
    if (activeTab === 'boost') return payment.is_boost === true
    if (activeTab === 'sent') {
        return (
            payment.from_user_id === currentUserId &&
            payment.to_user_id !== currentUserId &&
            payment.is_boost !== true
        )
    }
    if (activeTab === 'received') {
        return (
            payment.from_user_id !== currentUserId &&
            payment.to_user_id === currentUserId &&
            payment.is_boost !== true
        )
    }

    return true
}
